import React, { useEffect, useState } from "react";
import API from "../../../services/axiosInstance";
import { Row, Col, Card, Form, Button, Table, InputGroup } from "react-bootstrap";
import { useForm, useFieldArray } from 'react-hook-form';
import { useParams, useNavigate, Link } from "react-router-dom";
import Permission from "../../security/permission";
import { AUTH_CODE } from "../../security/authCodes";
import { useAuth } from "../../security/authContext";
// import useSubmitPrevent from "../../utils/SubmitPrevent";
import usePreventMultiClick from "../../utils/SubmitPrevent";

import { FormLoader, useFormLoader } from "../../common_modules/loader";
// import { upload } from "@testing-library/user-event/dist/upload";

const GamSetting = () => {
    const [publisherName, setpublisherName] = useState("");
    const { id, guid } = useParams();
    const navigate = useNavigate();

    const [matrix, setMatrix] = useState();
    const [hasSavedMatrix, setHasSavedMatrix] = useState(false);
    const [adPlacement, setAdplacement] = useState();
    // const [gamSetting, setGamSetting] = useState([
    //     { domain: "", subDomain: "", payoutPercentage: "", billingType: "", networkCode: "", ecpmValue: "" }
    // ]);
    
    // custom hook loader
    const { isLoading, startLoading, stopLoading } = useFormLoader();
    const { hasPermission } = useAuth();

    // const submittingRef  = useSubmitPrevent();
    const { btnClicked, setBtnClicked } = usePreventMultiClick();
    
    const { register, handleSubmit, control, formState: { errors }, setValue } = useForm({
        defaultValues: {
            gamSetting: [{
                domain: "",
                subDomain: "",
                payoutPercentage: "",
                billingType: "1",
                networkCode: "",
                ecpmValue: ""
            }]
        }
    });

    const { fields, append, remove, replace } = useFieldArray({
        control,
        name: "gamSetting"
    });

    // Gam matricx 
    // const getMatrixList = async () => {
    //     try {
    //         // 1️⃣ Always load the full matrix list
    //         const allRes = await API.get('/publisher/gam/metrics');
    //         const fullList = allRes?.data?.data || [];
    //         // 2️⃣ Try loading user-saved matrix (only exists in edit mode)
    //         let saved = [];
    //         try {
    //             const savedRes = await API.get(`/publisher/account/gam/metrics/${id}`);
    //             saved = savedRes?.data?.data || [];
    //         } catch (error) {
    //             saved = [];
    //         }
    //         // 3️⃣ Merge based on saved
    //         const mergedList = fullList.map(item => {
    //         const match = saved.find(s => s.metricId === item.id);

    //             return {
    //                 ...item,
    //                 isEditable: !!match, 
    //                 desiredName: match ? match.displayName : item.displayName,
    //                 desiredChineseName: match ? match.chineseName : item.chineseName
    //             };
    //         });
    //         setMatrix(mergedList);
    //     } catch (error) {
    //         console.error("Matrix load error:", error);
    //     }
    // };
    const getMatrixList = async () => {
        try {
            const allRes = await API.get('/publisher/gam/metrics');
            const fullList = allRes?.data?.data || [];
            console.log(fullList);

            let saved = [];
            try {
                const savedRes = await API.get(`/publisher/account/gam/metrics/${id}`);
                saved = savedRes?.data?.data || [];
                setpublisherName(savedRes?.data?.name)
                console.log(saved);

            } catch (error) {
                saved = [];
            }

            // Store flag: do we have saved data?
            setHasSavedMatrix(saved.length > 0);

            const mergedList = fullList.map(item => {
                const match = saved.find(s => s.metricId === item.id);
                return {
                    ...item,
                    savedId: match ? match.id : 0,
                    isEditable: !!match,
                    desiredName: match ? match.displayName : item.displayName,
                    desiredChineseName: match ? match.chineseName : item.chineseName
                };
            });

            setMatrix(mergedList);
        } catch (error) {
            console.error("Matrix load error:", error);
        }
    };

    const toggleEdit = (index) => {
        const updated = [...matrix];
        const currentRow = updated[index];
        if (!currentRow.isEditable) {
            const adxCtrSelected = updated.some(
                item => item.metricName === "adx_ctr" && item.isEditable
            );
            const ctrSelected = updated.some(
                item => item.metricName === "ctr" && item.isEditable
            );
            if (currentRow.metricName === "adx_ctr" && ctrSelected) {
                alert("You can select either ADX CTR (%) or CTR (%), not both.");
                return;
            }
            if (currentRow.metricName === "ctr" && adxCtrSelected) {
                alert("You can select either ADX CTR (%) or CTR (%), not both.");
                return;
            }
        }
        updated[index].isEditable = !updated[index].isEditable;
        setMatrix(updated);
    }

    const updateField = (index, field, value) => {
        const updated = [...matrix];
        updated[index][field] = value;
        setMatrix(updated);
    };

    // GAM setting add more and delete
    const addGamSetting = () => {
        //   setGamSetting(prev => [
        //     ...prev,
        //     { domain: "", subDomain: "", payoutPercentage: "", billingType: "1", networkCode: "", ecpmValue: "" }
        //  ])
        append({
            domain: "",
            subDomain: "",
            payoutPercentage: "",
            billingType: "1",
            networkCode: "",
            ecpmValue: ""
        })
    }

    const deleteGamSetting = (index) => {
        //  unregister(`gamSetting.${index}`);
        // setGamSetting(prev => prev.filter((_, i) => i !== index));
        remove(index);
    };

    // edit of ad placement 
    const loadAdPlacementData = async () => {
        try {
            const res = await API.get(`/publisher/adplacement/conf/${guid}`);
            const data = res?.data?.data;
            setpublisherName(res?.data?.name)

            setAdplacement(data);
            if (!data) return;

            // Prefill form fields using setValue()
            setValue("generationType", data.scriptGenType);
            setValue("autoClose", data.autoCloseTimer);
            setValue("callbackTimer", data.callbackTimer);
            setValue("pwdTimer", data.powByTimer);
            setValue("exactUrl", data.urlExactMatch);
            setValue("uploadExclusion", data.exclusionUrl);

        } catch (error) {
            console.error("Error loading Ad Placement settings:", error);
        }
    };

    // Gam setting at edit time 
    const loadGamSettingData = async () => {
        try {
            const res = await API.get(`/publisher/gam/${id}`);
            const data = res?.data?.data;
            setpublisherName(res?.data?.name)

            if (!data || data.length === 0) return;
            // Set gamSetting state for rendering dynamic forms
            // setGamSetting (
            //     data.map(item =>({
            //         domain: item.domain || "",
            //         subDomain: item.subdomain || "",
            //         payoutPercentage: item.payoutPerc || "",
            //         billingType: item.billingType || "",
            //         networkCode: item.networkCode || "",
            //         ecpmValue: item.ecpmValue || ""
            //     }))
            // )
            replace(
                data.map(item => ({
                    id: item.id || 0,
                    domain: item.domain || "",
                    subDomain: item.subdomain || "",
                    payoutPercentage: item.payoutPerc || "",
                    billingType: item.billingType ?? "1",
                    networkCode: item.networkCode || "",
                    ecpmValue: item.ecpmValue || ""
                }))
            );
            // data.forEach((item, index) => {
            //     setValue(`gamSetting.${index}.domain`, item.domain);
            //     setValue(`gamSetting.${index}.subDomain`, item.subdomain);
            //     setValue(`gamSetting.${index}.payoutPercentage`, item.payoutPerc);
            //     setValue(`gamSetting.${index}.billingType`, item.billingType);
            //     setValue(`gamSetting.${index}.networkCode`, item.networkCode);
            //     setValue(`gamSetting.${index}.ecpmValue`, item.ecpmValue);
            // });
        } catch (error) {
            console.error("Error loading GAM setting:", error);
        }

    }

    const downloadFile = async () => {
        if(btnClicked) return;
        setBtnClicked(true);
        startLoading();
        try {
            const response = await API.post('/publisher/adplacement/conf/download/exclusion/url/file',
                {
                    accGuid: guid,
                    fileName: adPlacement?.exclusionUrl
                },
                { responseType: "blob" }
            );

            // Extract filename from filePath
            const fileName = adPlacement?.exclusionUrl.split("/").pop();
            // Create a download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            console.log(response.data);

            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download Failed:", error);
            alert("Unable to download file!");
        } finally {
            setBtnClicked(false);
            stopLoading();
        }
    }

    const deleteExclusion = async (accGuid, fileName) => {
        try {
            if(window.confirm("Do you want to delete")) {
                const response = await API.delete(`/publisher/adplacement/conf/delete/exclusionfile/${accGuid}/${fileName}`);
                if (response?.data?.status === "Success") {
                    loadAdPlacementData();
                     window.location.reload();
                }
            } else {
                    return;
            }    
        } catch (error) {
            console.error("Download Failed:", error);
        }
    }

    const onSubmit = async (formData) => {
        if(btnClicked) return;
        setBtnClicked(true);
        startLoading();
        try {
            // if(submittingRef.current) return;
            // submittingRef.current = true;
            // startLoading();
            // filter only changed rows
            const matrixPayload = [];
            const hasEditible = matrix.some(row => row.isEditable);
            if (!hasEditible) {
                matrixPayload.push({
                    accId: id,
                    accGuid:guid,
                    status:0,
                    id:0,
                    metricId: 0,
                    metricName: "",
                    defaultName: "",
                    desiredName: "",
                    defaultChineseName: "",
                    desiredChineseName: "",
                })
            } else {
                for (let i = 0; i < matrix.length; i++) {
                    const row = matrix[i];
                    if (row.isEditable) {
                        // validation
                        if (!row.desiredName.trim() || !row.desiredChineseName.trim()) {
                            alert(`Row ${i + 1}: Name cannot be blank`);
                            return;
                        }
                        matrixPayload.push({
                            id: row?.savedId || 0,
                            accId: id,
                            accGuid:guid,
                            metricId: row.id,
                            metricName: row?.metricName,

                            defaultName: row?.displayName,
                            desiredName: row?.isEditable ? (row.desiredName).trim() : '',

                            defaultChineseName: row?.chineseName,
                            desiredChineseName: row?.isEditable ? (row.desiredChineseName).trim() : '',
                            sortOrder: row?.sortOrder,
                            metricInfo: row?.metricInfo,
                            metricChineseInfo: row?.metricChineseInfo,
                            status:1,
                        });
                    } 
                    // else if (hasSavedMatrix) {
                    //     matrixPayload.push({
                    //         accId: id,
                    //         status:0,
                    //     });
                    // }
                }
            }
            // -------------------------
            // 2️⃣ Prepare Ad Placement Payload
            // -------------------------        

            const adPlacementPayload = {
                id: adPlacement?.id || 0,
                accountId: id,
                accountGuid: guid,
                powByTimer: formData.pwdTimer,
                callbackTimer: formData.callbackTimer,
                autoCloseTimer: formData.autoClose,
                urlExactMatch: formData.exactUrl,
                scriptGenType: Number(formData.generationType),

            };
            const gamSettingPayload = formData.gamSetting.map((item) => ({
                id: item.id || 0,
                accountId: id,
                accountGuid: guid,
                domain: (item.domain).trim(),
                subdomain: (item.subDomain).trim(),
                payoutPerc: item.payoutPercentage,
                billingType: item.billingType,
                networkCode: item.networkCode,
                ecpmValue: (item.ecpmValue).trim(),
                status: 1
            }))
            // matrix api
            let matrixApi;

            if (hasSavedMatrix) {
                // const payloadWithStatus = matrixPayload.map(item => ({
                //     ...item,
                //     status: 1,
                // }));
                if (hasPermission(AUTH_CODE.accountGamMetrics.edit_UpdateGamMetrics)) {
                    matrixApi = API.put('/publisher/account/gam/metrics/update',
                        matrixPayload,
                    )
                }
            } else {
                if (hasPermission(AUTH_CODE.accountGamMetrics.createGamMetrics)) {
                    matrixApi = API.post('/publisher/account/gam/metrics/save', matrixPayload)
                }
            }
            // File upload
            const uploadedFile = formData.uploadExclusion?.[0];
            // Create FormData only if a NEW file is selected
            let fileData = null;
            if (uploadedFile instanceof File && uploadedFile.size > 0) {
                fileData = new FormData();
                fileData.append("file", uploadedFile);
            }
            // if(uploadedFile){
            //     fileData = new FormData();
            //     fileData.append("file", uploadedFile);
            //     console.log(uploadedFile);
            // }

            // -------------------------
            // 3️⃣ Call APIs Sequentially
            // -------------------------

            // call Matrix API here
            const responses = await Promise.all([
                matrixApi ? matrixApi : Promise.resolve({ data: { status: "Success" } }),
                hasPermission(AUTH_CODE.adPlacementConf.adPlacementConfiguration) ? API.put('/publisher/adplacement/conf/save', adPlacementPayload) : Promise.resolve({ data: { status: "Success" } }),
                hasPermission(AUTH_CODE.gamSetting.createUpdateGamSetting) ? API.put('/publisher/gam/save', gamSettingPayload) : Promise.resolve({ data: { status: "Success" } }),
                // Only call upload API if a file is selected
                fileData ?
                    hasPermission(AUTH_CODE.adPlacementConf.uploadExclusionUrl) ?
                        API.post(`/publisher/adplacement/conf/upload/exclusionurl/${guid}/${id}`,
                            fileData
                        )
                        : Promise.resolve({ data: { status: "Success" } })
                    : Promise.resolve({ data: { status: "Success" } })
            ]);
            // Check if every API response has status === "Success"
            const isAllSuccess = responses.every(
                (res) => res?.data?.status === "Success"
            );
            if (isAllSuccess) {
                alert("Data saved successfully!!");
                window.location.reload();
                // navigate(`/publisher/adplacement-list/${id}/${guid}`);
            } else {
                alert("Something went wrong");
            }
        } catch (error) {
            console.error("Error saving data:", error);
        } finally {
            setBtnClicked(false);
            // submittingRef.current = false;
            stopLoading();
            // window.load();
        }
    };

    useEffect(() => {
        getMatrixList();
        loadAdPlacementData();
        loadGamSettingData();
    }, []);

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <Permission code={AUTH_CODE.accounts.publisherListing}>
                    <Link to={'/active-publisher'}><span>Publisher</span></Link>
                </Permission>
                {/* <span>{publisherName}</span> */}
                <Link to={`/publisher/info/${id}/${guid}`}><span>{publisherName}</span></Link>
                <span>Gam Setting</span>
                {/* <span>{id}</span> */}
            </div>
            <Card className="p-3 instreamRows">
                <span className="text-danger" style={{ fontSize: "12px" }}>All fields marked with * are mandatory</span>
                <form onSubmit={handleSubmit(onSubmit)}>
                    {
                        hasPermission(AUTH_CODE.accountGamMetrics.createGamMetrics) || hasPermission(AUTH_CODE.accountGamMetrics.edit_UpdateGamMetrics)
                            ?
                            <Card className="p-3">
                                <div className="mt-0 table-wrapper mt-3">
                                    <Table striped bordered responsive hover size="sm" className="align-middle ">
                                        <thead>
                                            <tr>
                                                <th>☰</th>
                                                <th>List</th>
                                                <th>Original Name</th>
                                                <th>Display Name</th>
                                                <th>Chinese Name</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {matrix?.length > 0
                                                ? matrix.map((row, index) => (
                                                    row.isDefault === 1 ? (
                                                        <tr key={row.id}>
                                                            <td>{index + 1}</td>

                                                            {/* Checkbox */}
                                                            <td>
                                                                <InputGroup.Checkbox
                                                                    checked={row.isEditable}
                                                                    onChange={() => toggleEdit(index)}
                                                                />
                                                            </td>

                                                            {/* Original Name */}
                                                            <td>{row.displayName}</td>

                                                            {/* Editable English Name */}
                                                            <td>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={row.desiredName}
                                                                    readOnly={!row.isEditable}
                                                                    onChange={(e) =>
                                                                        updateField(index, "desiredName", e.target.value)
                                                                    }
                                                                />
                                                            </td>

                                                            {/* Editable Chinese Name */}
                                                            <td>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={row.desiredChineseName}
                                                                    readOnly={!row.isEditable}
                                                                    onChange={(e) =>
                                                                        updateField(index, "desiredChineseName", e.target.value)
                                                                    }
                                                                />
                                                            </td>
                                                        </tr>
                                                    ) : null
                                                ))
                                                : <tr>
                                                    <td colSpan={5}>No Data Available</td>
                                                </tr>}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card>
                            : ""
                    }
                    {/* Ad placement setting*/}
                    <Permission code={AUTH_CODE.adPlacementConf.adPlacementConfiguration}>
                        <Card className="p-3 mt-5">
                            <h6 className="subTitle">Ad Placement Setting</h6>
                            <Row>
                                <Col md={3}>
                                    <label>Script Generation Type</label>
                                </Col>
                                <Col md={5}>
                                    <Form.Select {...register("generationType")}>
                                        <option value="1">Generate Bundle JS</option>
                                        <option value="0">Generate JSON</option>
                                        <option value="2">Generate AMP JS</option>
                                        <option value="3">Generate AMP Bundle JS</option>
                                        <option value="4">Generate AMP + JSON</option>
                                        <option value="5">Generate Bundle AMP + JSON</option>
                                        <option value="-1">None</option>
                                    </Form.Select>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <label>Auto Close Ad Timer (In seconds)</label>
                                </Col>
                                <Col md={5}>
                                    <Form.Control type="number" placeholder="Enter here..." {...register("autoClose")} />
                                    {/* {errors.autoClose && <p className="text-danger">{errors.autoClose.message}</p>} */}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <label>Callback Timer (In seconds)</label>
                                </Col>
                                <Col md={5}>
                                    <Form.Control type="number" defaultValue={5} placeholder="Enter here..." {...register("callbackTimer")} />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <label>Powered By Timer (In seconds)</label>
                                </Col>
                                <Col md={5}>
                                    <Form.Control type="number" defaultValue={5} placeholder="Enter here..." {...register("pwdTimer")} />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <label>Exact Match Url</label>
                                </Col>
                                <Col md={5}>
                                    <Form.Select {...register("exactUrl")}>
                                        <option value="">No</option>
                                        <option value="1">Yes</option>
                                    </Form.Select>
                                </Col>
                            </Row>
                            <Row>
                                <Permission code={AUTH_CODE.adPlacementConf.uploadExclusionUrl}>
                                    <Col md={3}>
                                        <label>Upload Exclusion Url</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Control type="file" {...register("uploadExclusion")} />
                                    </Col>
                                </Permission>
                            </Row>
                            <Row>
                                {
                                    adPlacement?.exclusionUrl?.trim() && (
                                        <>
                                            <Permission code={AUTH_CODE.adPlacementConf.downloadExclusionUrl}>
                                                <Col md={6}>
                                                    <Button type="button" variant="success" className="mt-3 submitBtn" size="sm" onClick={() => downloadFile()} style={{textTransform:"none"}}>Download Exclusion Url File</Button>
                                                </Col>
                                            </Permission>
                                            <Permission code={AUTH_CODE.adPlacementConf.deleteExclusionUrl}>
                                                <Col md={4}>
                                                    <Button type="button" variant="danger" className="mt-3 submitBtn" size="sm" onClick={() => deleteExclusion(adPlacement?.accountGuid, adPlacement?.exclusionUrl)} style={{textTransform:"none"}}>Delete</Button>
                                                </Col>
                                            </Permission>
                                        </>
                                    )}
                            </Row>
                        </Card>
                    </Permission>
                    {/* GAM setting*/}
                    <Permission code={AUTH_CODE.gamSetting.createUpdateGamSetting}>
                        <Card className="p-3 mt-5">
                            <div className="d-flex justify-content-between align-items-center">
                                <h6 className="subTitle">GAM Setting</h6>
                            </div>
                            {
                                fields.map((item, index) => (
                                    <Card className="p-3 my-3" key={item?.id} style={{ background: "#f9f9f9" }}>
                                        <div className="d-flex justify-content-between">
                                            <h6>Setting #{index + 1}</h6>

                                            {fields.length > 1 && (
                                                <Button variant="danger" size="sm" onClick={() => deleteGamSetting(index)}>
                                                    Delete
                                                </Button>
                                            )}
                                        </div>
                                        <Row>
                                            <Col md={3}>
                                                <label>Domain</label>
                                            </Col>
                                            <Col md={5}>
                                                <Form.Control type="text" placeholder="Enter here..." {...register(`gamSetting.${index}.domain`, { required: "domain is required" })} />
                                                {errors.gamSetting?.[index]?.domain && (<p className="text-danger">Setting #{index + 1} : {errors.gamSetting[index].domain.message}</p>)}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={3}>
                                                <label>SubDomain</label>
                                            </Col>
                                            <Col md={5}>
                                                <Form.Control type="text" placeholder="Enter here..." {...register(`gamSetting.${index}.subDomain`)} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={3}>
                                                <label>Payout Percentage</label>
                                            </Col>
                                            <Col md={5}>
                                                <Form.Control type="number" step="any" placeholder="Enter here..." {...register(`gamSetting.${index}.payoutPercentage`)} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={3}>
                                                <label>Billing Type</label>
                                            </Col>
                                            <Col md={5}>
                                                <Form.Select {...register(`gamSetting.${index}.billingType`)}>
                                                    <option value="1">ADX</option>
                                                    <option value="2">ADX+OpenBidding</option>
                                                    <option value="3">ADX+OpenBidding with ADX Request</option>
                                                    <option value="0">All Demand Channel</option>
                                                </Form.Select>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={3}>
                                                <label>Network Code</label>
                                            </Col>
                                            <Col md={5}>
                                                <Form.Control type="number" placeholder="Enter here..." {...register(`gamSetting.${index}.networkCode`)} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={3}>
                                                <label>eCPM</label>
                                            </Col>
                                            <Col md={5}>
                                                <Form.Control type="text" placeholder="Enter here..." {...register(`gamSetting.${index}.ecpmValue`)} />
                                            </Col>
                                        </Row>
                                    </Card>
                                ))
                            }
                            <Button variant="success" onClick={addGamSetting} style={{ width: '120px', borderRadius: '0' }}>
                                + Add More
                            </Button>
                        </Card>
                    </Permission>
                    <Button type="submit" variant="primary" className="mt-3 submitBtn" size="lg">Submit</Button>
                </form>
            </Card>
        </FormLoader>
    )
}

export default GamSetting;